import { getInitialWidth } from '@/redux/modules/windowSize';
import { useAppSelector } from '@/redux/hooks';
import useWindowSize from '@liveauctioneers/caterwaul-components/lib/hooks/useWindowSize';

const useWindowSizeCustom: typeof useWindowSize = (initialSSRWidth) => {
    const initialWidth = useAppSelector(getInitialWidth);

    return useWindowSize(initialSSRWidth || initialWidth);
};

export default useWindowSizeCustom;
